import { Icon } from '@platform/components';
import ContentPanel from './ContentPanel';
import HighlightedIconCircle from './HighlightedIconCircle';
import { H2, Description } from './utils';
import cx from 'classix';

const VerticalFeaturePanel = ({
  title,
  description,
  subtitle,
  items,
  image,
}: {
  title: string;
  description?: string;
  subtitle?: string;
  items: string[];
  image: string;
}) => {
  return (
    <ContentPanel>
      <H2>{title}</H2>
      {description && <Description>{description}</Description>}
      {subtitle && (
        <div className='mb-8 sm:mb-10 text-gray-800 text-xl font-semibold'>{subtitle}</div>
      )}
      <div
        className={cx(
          'grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-16',
          !subtitle && 'mt-12 sm:mt-16',
        )}
      >
        <div className='flex flex-col gap-10 sm:gap-12'>
          {items.map((item, index) => (
            <div key={index} className='mt-2 flex gap-4 sm:items-center'>
              <HighlightedIconCircle color='green'>
                <Icon type='check-square-broken' size='24' />
              </HighlightedIconCircle>
              <div className='text-gray-800 text-lg font-medium leading-7'>{item}</div>
            </div>
          ))}
        </div>
        <img className='w-full aspect-auto' src={image} />
      </div>
    </ContentPanel>
  );
};

export default VerticalFeaturePanel;
